// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpecialField_wrapper__rbVLy","subtitle":"SpecialField_subtitle__1tHi-","list":"SpecialField_list__pW4vQ","listItem":"SpecialField_listItem__2DStc"};